module.exports = __webpack_public_path__ + "static/img/img_dsjfx.c6a0228.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_dsjfx.png
// module id = ZP3X
// module chunks = 0